import React, { memo, useState } from 'react';
import dayjs from 'dayjs';
import { checkDatePrinted, getOrderGross } from '@/react/OrderHistoryView/OrderHistoryView.logic.tsx';
import { DeliveryStatus, OrderStatus, type OrderStrip } from '@/pos/OrderType.ts';
import clsx from 'clsx';
import _ from 'lodash'
import { LL3 } from "@/react/core/I18nCurrency.tsx";
import PortalPopup from "@delivery-management/PortalPopup.tsx";
import MoreActions from "@delivery-management/DeliveyMangement/Popup/MoreActions.tsx";
import {
  DeliveryStatusIcon,
  PLATFORM,
  setOnlineOrder0
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import PaymentMethod from "@order-history/PaymentMethod.tsx";
import CompleteOrder from "@delivery-management/DeliveyMangement/Popup/CompleteOrder.tsx";
import CancelOrder from "@delivery-management/DeliveyMangement/Popup/CancelOrder.tsx";
import BookDriver from "@delivery-management/DeliveyMangement/Popup/BookDriver.tsx";
import ViewOrderDetail from "@delivery-management/DeliveyMangement/Popup/ViewOrderDetail.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";
import { useComputed } from "@/react/core/reactive.ts";
import { LL2 } from "@/react/core/I18nBackend.tsx";
import ViewOrderMap from "@delivery-management/DeliveyMangement/Popup/ViewOrderMap.tsx";
import PortalDrawer from "@delivery-management/PortalDrawer.tsx";

interface OrderHistoryTableRowProps {
  order?: OrderStrip;
  _id?: string;
  isEven?: boolean;
  isSelected?: boolean;
}

const OrderHistoryTableRow = memo(({ order, _id, isEven, isSelected }: OrderHistoryTableRowProps) => {
  if (!order) return <></>
  const [isOpenMoreActionsPopup, setIsOpenMoreActionsPopup] = useState(false);


  const [isOpenViewOrderDetailPopup, setIsOpenViewOrderDetailPopup] = useState(false);
  const [isOpenViewOrderMapPopup, setIsOpenViewOrderMapPopup] = useState(false);
  const [isOpenAssignDriverPopup, setIsOpenAssignDriverPopup] = useState(false);
  const [isOpenCancelOrderPopup, setIsOpenCancelOrderPopup] = useState(false);
  const [isOpenCompleteOrderPopup, setIsOpenCompleteOrderPopup] = useState(false);

  const getStatus = (order) => {
    const status = order.deliveryStatus as DeliveryStatus;
    const LL = LL0().delivery.deliveryStatus
    let icon = "";
    let text = LL.unknownStatus();

    if (status && Object.values(DeliveryStatus).includes(status)) {
      icon = DeliveryStatusIcon[status]
      if (status === DeliveryStatus.AWAITING_KITCHEN_APPROVAL) {
        text = LL.awaitingKitchenApproval({
          date: dayjs().format(LL2().dates.dateFormat()),
          time: dayjs().format(LL2().dates.timeFormat())
        })
      } else if (status === DeliveryStatus.UPCOMING) {
        text = LL.upcoming({
          date: dayjs(order.pickupDate).format(LL2().dates.dateFormat()),
          time: dayjs(order.pickupDate).format(LL2().dates.timeFormat())
        })
      } else {
        text = _.get(LL, status)?.()
      }
    }
    return { icon, text }
  }

  return (

    <>
      <div
        className={clsx('!text-[#1e1e23] bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row items-center justify-center py-[7px] px-1.5 relative text-smi text-text-color-black-1e1e23-400 border-solid border-black-solid-black-700-364150 sm:relative sm:min-w-[40px]', isEven && "bg-white")}
        onClick={() => {
          setOnlineOrder0(order)
          checkDatePrinted(order?.date!)
        }}
      >
        <div className="relative text-[13px] mq768:text-[12px] h.414:text-[12px]">{order.id}</div>
      </div>
      <div
        className={clsx('!text-[#1e1e23] bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row items-center justify-center py-[7px] px-1.5 relative text-smi text-text-color-black-1e1e23-400 border-solid border-black-solid-black-700-364150 border-l-[1px] sm:relative', isEven && "bg-white")}
        onClick={() => {
          setOnlineOrder0(order)
          checkDatePrinted(order?.date)
        }}
      >
        {order.date &&
          <div className="relative text-[13px] mq768:text-[12px] h.414:text-[12px]">{dayjs.unix(order.date || 0).format('hh:mmA')}</div>
        }
      </div>
      <div
        className={clsx('!text-[#1e1e23] bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row items-center justify-start py-[7px] px-1.5 relative text-smi text-text-color-black-1e1e23-400 border-solid border-black-solid-black-700-364150 border-l-[1px] sm:relative', isEven && "bg-white")}
        onClick={() => {
          setOnlineOrder0(order)
          checkDatePrinted(order?.date)
        }}
      >
        {!_.isEmpty(order.customerRaw) && (
          <div className="flex flex-col items-start justify-start text-left">
            <b
              className="w-full relative text-[#ba5eba] text-[13px] mq768:text-[12px] h.414:text-[12px]">
              {order.customerRaw!.name || ''} {order.customerRaw!.phone ? ` - ${order.customerRaw!.phone}` : ''}
            </b>
            <div
              className="w-full relative leading-[15px] text-[#303030] [display:-webkit-inline-box] overflow-hidden text-ellipsis [-webkit-line-clamp:2] [-webkit-box-orient:vertical] text-[13px] mq768:text-[12px] h.414:text-[12px]">
              {order.customerRaw!.address || ''}
            </div>
          </div>
        )}
      </div>
      <div
        className={clsx('!text-[#1e1e23] bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row gap-1 items-center justify-start py-[7px] px-1.5 relative text-smi text-text-color-black-1e1e23-400 border-solid border-black-solid-black-700-364150 border-l-[1px] Tablet_600:relative Mobile_480:relative mq320:relative', isEven && "bg-white",
          [OrderStatus.CANCELLED, OrderStatus.CANCELLED_BEFORE_PAID].includes(order.status) && "line-through")}
        onClick={() => {
          setOnlineOrder0(order)
          checkDatePrinted(order?.date)
        }}
      >
        <PaymentMethod isShowText={false} payments={order.payments} />
        <div className="relative text-[13px] mq768:text-[12px] h.414:text-[12px]">{LL3().format.currency(getOrderGross(order))}</div>
      </div>
      <div
        className={clsx('!text-[#1e1e23] bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row items-center justify-start py-[7px] px-1.5 gap-[2px] relative text-smi text-text-color-black-1e1e23-400 border-solid border-black-solid-black-700-364150 border-l-[1px] Tablet_600:relative', isEven && "bg-white")}
        onClick={() => {
          setOnlineOrder0(order)
          console.log(order)
          checkDatePrinted(order?.date)
        }}
      >
        <img src={PLATFORM[order?.provider || "phone"]?.icon || ''} alt="" width={28} />
        <span className="mq600:hidden text-[13px] mq768:text-[12px] h.414:text-[12px]">{PLATFORM[order?.provider || "phone"]?.name}</span>
      </div>
      <div
        className={clsx('bg-gray-solid-gray-180-ebecee box-border border-r-[1px] min-h-[55px] p-2 flex flex-row items-center justify-start py-[7px] px-1.5 gap-[8px] relative text-left text-smi text-gray-500 border-solid border-black-solid-black-700-364150 border-l-[1px] text-[13px] mq768:text-[12px] h.414:text-[12px]', isEven && "bg-white")}
        onClick={() => {
          setOnlineOrder0(order)
          checkDatePrinted(order?.date)
        }}
      >
        <img src={getStatus(order)?.icon || ''} width={28} className="mq600:hidden" alt="" />
        {getStatus(order).text}
      </div>
      <div
        ref={makeRipple}
        className={clsx('bg-gray-solid-gray-180-ebecee box-border min-h-[55px] p-2 flex flex-row items-center justify-center py-[7px] px-1.5 gap-[8px] relative text-smi text-gray-500 border-solid border-black-solid-black-700-364150',
          isEven && "bg-white"
        )}
        onClick={() => {
          setOnlineOrder0(order)
          setIsOpenMoreActionsPopup(true)
        }}
      >
        <img
          className="w-[32px] relative h-[32px] object-cover sm:w-[28px] sm:h-[28px] mq600:w-[24px] mq600:h-[24px] h.414:w-[24px] h.414:h-[24px]"
          alt=""
          src="/iconmore@2x.png"
        />
      </div>
      {isOpenMoreActionsPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenMoreActionsPopup(false)}
        >
          <MoreActions
            onClose={() => setIsOpenMoreActionsPopup(false)}
            onCompleteOrder={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenCompleteOrderPopup(true)
            }}
            onCancelOrder={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenCancelOrderPopup(true)
            }}
            onViewOrderCancellation={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenCancelOrderPopup(true)
            }}
            onAssignDriver={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenAssignDriverPopup(true)
            }}
            onViewOrderDetail={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenViewOrderDetailPopup(true)
            }}
            onViewMap={() => {
              setIsOpenMoreActionsPopup(false)
              setIsOpenViewOrderMapPopup(true)
            }}
          />
        </PortalPopup>}

      {isOpenCompleteOrderPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenCompleteOrderPopup(false)}
        >
          <CompleteOrder onClose={() => setIsOpenCompleteOrderPopup(false)} />
        </PortalPopup>
      }
      {isOpenCancelOrderPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenCancelOrderPopup(false)}
        >
          <CancelOrder onClose={() => setIsOpenCancelOrderPopup(false)} />
        </PortalPopup>
      }
      {isOpenAssignDriverPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenAssignDriverPopup(false)}
        >
          <BookDriver onClose={() => setIsOpenAssignDriverPopup(false)} />
        </PortalPopup>
      }
      {isOpenViewOrderDetailPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenViewOrderDetailPopup(false)}
        >
          <ViewOrderDetail onClose={() => setIsOpenViewOrderDetailPopup(false)} />
        </PortalPopup>
      }
      {isOpenViewOrderMapPopup &&
        <PortalDrawer
          overlayColor="rgba(0, 0, 0, 0.5)"
          placement="Bottom"
          onOutsideClick={() => setIsOpenViewOrderMapPopup(false)}
        >
          <ViewOrderMap onClose={() => setIsOpenViewOrderMapPopup(false)} />
        </PortalDrawer>
      }
    </>
  );
});

export default OrderHistoryTableRow;